// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2KL-r","content":"LoadingAlert_content__B6UPj"};